import axios from "axios";
import React, { useEffect, useState } from "react"

/* icons */

const Footer = ({ language }) => {

    return (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <small style={{ color: 'grey', fontSize: '11px' }}>
                powered by <a style={{ color: 'grey' }} href={`https://organizer.ticketino.com/${language}`} target="_blank" rel="noreferrer">TICKETINO</a>
            </small>
        </div>
    );
};

export default Footer;
